import { formatNumber, formatPercent, formatRial, nodeLabel } from './chainFormat';

export const STACK_TOP = 84;
const BOX_W = 108;
const BOX_H = 50;
const BOX_GAP = 6;
const CHIP_H = 24;
const BOX_STEP = BOX_H + BOX_GAP;

/** Bottom edge (in SVG units) of a stack with `count` boxes plus its total chip. */
export const stackBottom = (count) => STACK_TOP + count * BOX_STEP + CHIP_H;

/** SVG group: one box per paying buyer, then a total chip. */
export default function NodeEarningsStack({ x, boxes, total }) {
    if (boxes.length === 0) return null;

    const chipY = STACK_TOP + boxes.length * BOX_STEP;

    return (
        <g className="chain-graph-stack" aria-hidden="true">
            {boxes.map((box) => {
                const y = STACK_TOP + boxes.indexOf(box) * BOX_STEP;
                return (
                    <g key={`${box.buyerIndex}-${box.level}`}>
                        <rect
                            className="chain-graph-box"
                            x={x - BOX_W / 2}
                            y={y}
                            width={BOX_W}
                            height={BOX_H}
                            rx="8"
                        />
                        <text
                            className="chain-graph-box-amount"
                            x={x}
                            y={y + 19}
                            textAnchor="middle"
                            direction="rtl"
                        >
                            {formatRial(box.amount)}
                        </text>
                        <text
                            className="chain-graph-box-percent"
                            x={x}
                            y={y + 32}
                            textAnchor="middle"
                        >
                            {formatPercent(box.percent)}
                        </text>
                        <text
                            className="chain-graph-box-source"
                            x={x}
                            y={y + 44}
                            textAnchor="middle"
                            direction="rtl"
                        >
                            از {nodeLabel(box.buyerIndex)} · سطح {formatNumber(box.level)}
                        </text>
                    </g>
                );
            })}
            <g className="chain-graph-total">
                <rect
                    x={x - BOX_W / 2}
                    y={chipY}
                    width={BOX_W}
                    height={CHIP_H}
                    rx="12"
                />
                <text
                    className="chain-graph-total-text"
                    x={x}
                    y={chipY + 16}
                    textAnchor="middle"
                    direction="rtl"
                >
                    جمع: {formatRial(total)}
                </text>
            </g>
        </g>
    );
}